// @flow
// Externals
import React, { useMemo, useRef, useEffect } from "react";
import Lottie from "react-lottie-player";

// Custom hooks
// import { useDesktop } from "../../utils/useDesktop";

// Styles
// $FlowFixMe
import "./index.scss";

// Animation Data
import animationDataHorse from "../../static/lottie/Q7_Livestock.json";
import animationDataBird from "../../static/lottie/Q7_Small_Animals.json";
import animationDataCats from "../../static/lottie/Q7_Cats.json";

// const getAnimation = (animationData, cssClass) => {
// 	// Second: make all opacity of the animation 0.2
// 	return (
// 		<div className={`animation ${cssClass}`} key={cssClass}>
// 			<Lottie
// 				className="lottie-container basic"
// 				animationData={animationData}
// 				play={true}
// 				loop={true}
// 			/>
// 		</div>
// 	);
// };

// Question Animation
/*::
type Props = {
	value: string
}
*/
const Animation = (props /*: Props */) /*: any */ => {
	const FULL_OPACITY = 1;
	const HALF_OPACITY = 0.2;
	const lottieAnimations = [];

	// Refs
	const horseRef = useRef();
	// const goatRef = useRef();
	// const sheepRef = useRef();
	const catRef = useRef();
	// const rabbitRef = useRef();
	const birdRef = useRef();
	// const gerbilRef = useRef();
	// const chickenRef = useRef();
	// const isDesktop = useDesktop();

	const isLivestock = useMemo(() => {
		// returns -1 if the value is not found.
		return props.value.indexOf("Livestock") !== -1;
	}, [props.value]);
	const isCat = useMemo(() => {
		// returns -1 if the value is not found.
		return props.value.indexOf("Cat(s)") !== -1;
	}, [props.value]);
	const isSmallPet = useMemo(() => {
		// returns -1 if the value is not found.
		return props.value.indexOf("Small pets") !== -1;
	}, [props.value]);

	useEffect(() => {
		horseRef.current.style.opacity = HALF_OPACITY;
		catRef.current.style.opacity = HALF_OPACITY;
		birdRef.current.style.opacity = HALF_OPACITY;
	}, []);

	const getAnimation = (animationData, cssClass, ref) => {
		// Second step: make all opacity of the animation 0.2
		return (
			<div
				ref={ref}
				className={`animation-multi-part ${cssClass}`}
				key={cssClass}
			>
				<Lottie
					className="lottie-container basic"
					animationData={animationData}
					play={true}
					loop={true}
				/>
			</div>
		);
	};

	// if(isDesktop) return null

	if (isLivestock) {
		horseRef.current.style.opacity = FULL_OPACITY;
	} else {
		if (horseRef.current) {
			horseRef.current.style.opacity = HALF_OPACITY;
		}
	}

	if (isCat) {
		catRef.current.style.opacity = FULL_OPACITY;
	} else {
		if (catRef.current) {
			catRef.current.style.opacity = HALF_OPACITY;
		}
	}

	if (isSmallPet) {
		birdRef.current.style.opacity = FULL_OPACITY;
	} else {
		if (birdRef.current) {
			birdRef.current.style.opacity = HALF_OPACITY;
		}
	}

	// First Step: display all the animations:
	lottieAnimations.push(
		getAnimation(animationDataHorse, "horse", horseRef),

		getAnimation(animationDataCats, "cat", catRef),

		getAnimation(animationDataBird, "bird", birdRef),
	);

	return <>{lottieAnimations.map((lottieAnimation) => lottieAnimation)}</>;
};

// Exports
export default Animation;
